import React, { Component } from "react";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import { Table } from 'antd';
import moment from 'moment';
import _ from 'underscore';
import * as assignmentActions from '../../../redux/actions/assignmentActions';
import FindCostObjectForm from './FindCostObjectForm';
import Spinner from '../../Theme/Spinner';
import Pagination from './Pagination';

const ALL = 0;
const WBS_ELEMENT = 1;
const COST_CENTER = 2;
const DEFAULT_COST_CENTER = 3;
const PROJECT_DEFINITION = 4;

class FindCostObject extends Component {
  constructor(props) {
    super(props);
    this.state = {
      costObjects: '',
      parameters: {
      costObjectName: '%',
      costObjectNumber: '%',
      onlyValidItems: true,
      requestDate: this.props.requestDate,
      category: 0,
      findBy: 0,
      pageNo: 0
      },
      costObjectNameLabel: 'Cost Object Name',
      costObjectNumberLabel: 'Cost Object #',
      loading: false,
      costObjectTable: {
        columns: [
          {
            title: 'Row',
            dataIndex: 'key',
            render: text => <a>{text}</a>
          },
          {
            title: 'Cost Object',
            dataIndex: 'costObjectName',
            render: text => <a>{text}</a>
          },
          {
            title: 'Type',
            dataIndex: 'costObjectType',
            render: text => <a>{text}</a>
          },
          {
            title: 'WBS Element Category',
            dataIndex: 'wbsElementCategory',
            render: text => <a>{text}</a>
          },
          {
            title: 'Cost Object #',
            dataIndex: 'costObjectNumber',
            render: text => <a>{text}</a>
          }
        ],
        data: ''
      },
    };
  }

  handleFindByChange = (e) => {
    const { parameters } = this.state;
    let costObjectNameLabel;
    let costObjectNumberLabel;
    switch (e.target.value) {
      case ALL:
        costObjectNameLabel = "Cost Object Name";
        costObjectNumberLabel = "Cost Object #";
          break;
      case WBS_ELEMENT:
        costObjectNameLabel = "WBS Element Name";
        costObjectNumberLabel = "WBS Element #";
          break;
      case COST_CENTER:
        costObjectNameLabel = "Cost Object Name";
        costObjectNumberLabel = "Cost Object #";
          break;
      case DEFAULT_COST_CENTER:
        costObjectNameLabel = "Default Cost Center Name";
        costObjectNumberLabel = "Default Cost Center #";
          break;
      case PROJECT_DEFINITION:
        costObjectNameLabel = "Project Definition Name";
        costObjectNumberLabel = "Project Definition #";
          break;
      default:
        costObjectNameLabel = "Cost Object Name";
        costObjectNumberLabel = "Cost Object #";
  }
  parameters.findBy = e.target.value;
  parameters.category = 0; // every time radio button changes, should reset category, even for WBS Element
    this.setState({
      parameters,
      costObjectNameLabel,
      costObjectNumberLabel
    });
  }

  handleOmnibusFieldChange = (e) => {
    const { parameters } = this.state;
    let field;
    let value;
    // select dropdown
    if (typeof e === 'string') {
      field = e.split('-')[0];
      value = e.split('-')[1];
    }
    if (typeof e === 'object') {
      field = e.target.name;
      // checkbox
      if (e.target.type === 'checkbox') {
        value = e.target.checked;
      } else { // text input
        value = e.target.value || '%';
      }
    }
    // update state
    parameters[`${field}`] = value;
    this.setState({
      parameters
    });
  }

  handleSearch = async () => {
    const parameters = {
      costObjectName: this.state.parameters.costObjectName,
      costObjectNumber: this.state.parameters.costObjectNumber,
      onlyValidItems: this.state.parameters.onlyValidItems,
      requestDate: this.state.parameters.requestDate,
      category: this.state.parameters.category,
      findBy: this.state.parameters.findBy,
      pageNo: this.state.parameters.pageNo
    };
    this.setState({
      loading: true
    });
    await this.props.actions.fetchCostObjects(parameters)
      .catch(error => {
        if (!_.isEmpty(error)) {
          alert("Loading getServicesByDate failed\n" + JSON.stringify(error));
        }
      });
    this.setState({
      costObjects: this.props.costObjects.data,
      loading: false,
    }, () => {
      this.generateCostObjectTable();
    });
  }

  generateCostObjectTable = async () => {
    const data = [];
    const { costObjectTable } = this.state;
    const costObjects = this.state.costObjects;
    for (let costObject of costObjects) {
      const row = {
        key: costObject.rowIdTot,
        id: costObject.costObjectId,
        costObjectName: costObject.name,
        costObjectType: costObject.costObjectType,
        wbsElementCategory: costObject.wbsElementCategory,
        costObjectNumber: costObject.costObjectNumber
      };
      data.push(row);
    }
    costObjectTable.data = data;
    this.setState({
      costObjectTable
    });
  }

  updateState = (key, value) => {
    this.setState({
      [key]: value
    });
  }

  handleRowClick = async (record) => {
    await this.props.handleSelectCostObject(record);
    this.props.handleModalCancel();
  }

  render(){
    // console.log(this.props.costObjects); // debug
    // console.log(this.state.parameters); // debug
    const { loading } = this.state;
    const { pageNo } = this.state.parameters;
    const { rowCount } = this.props.costObjects;
    return (
      <React.Fragment>
          <FindCostObjectForm
            state={this.state}
            updateState={this.updateState}
            handleFindByChange={this.handleFindByChange}
            handleOmnibusFieldChange={this.handleOmnibusFieldChange}
            handleSearch={this.handleSearch}
          />
            { this.state.costObjectTable.data && !loading &&
              (
                <div>
                  <Table
                    columns={this.state.costObjectTable.columns}
                    dataSource={this.state.costObjectTable.data}
                    size="small"
                    onRow={record => ({
                      onClick: (e) => this.handleRowClick(record)
                    })}
                  />
                  Results: {rowCount} rows across {rowCount <= 100 ? `${1} batch` : `${(parseInt(rowCount / 100) + 1)} batches`}
                  &nbsp; <i>(1 batch = 100 rows)</i>
                  <br/>
                  Current Batch: {pageNo}
                  <br/>
                  <Pagination
                    rowCount={rowCount}
                    pageNo={pageNo}
                    state={this.state}
                    updateState={this.updateState}
                    handleSearch={this.handleSearch}
                  />
                </div>
              )
            }

            { loading &&
              <Spinner/>
            }
      </React.Fragment>
    );
  }
}

FindCostObject.propTypes = {
  costObjects: PropTypes.object,
}

function mapStateToProps(state) {
  return {
    costObjects: state.costObjects,
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      fetchCostObjects: bindActionCreators(
        assignmentActions.fetchCostObjects,
        dispatch
      ),
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FindCostObject);



// WEBPACK FOOTER //
// ./src/Components/Schedule/SelectCostObject/FindCostObject.js